import React from 'react';

const Prose = ({ className, content }) => {
  const proseClasses =
    'prose prose-lg max-w-none prose-headings:font-normal prose-h1:font-bold prose-h2:text-4xl prose-h3:text-3xl';

  /* eslint-disable-next-line react/no-danger */
  return <div className={`${proseClasses} ${className}`} dangerouslySetInnerHTML={{ __html: `${content}` }} />;
};

export default Prose;
